export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'createdAt',
    label: 'Created',
    sortable: false,
  },
  {
    name: 'updatedAt',
    label: 'Updated',
    sortable: false,
  },
  {
    name: 'deletedAt',
    label: 'Deleted',
    sortable: false,
  },
  {
    name: 'accessTokenExpiresAt',
    label: 'Access Token Expires',
    sortable: false,
  },
  {
    name: 'refreshTokenExpiresAt',
    label: 'Refresh Token Expires',
    sortable: false,
  },
];

export const columnsLabels = {};

export const schema = {};

export const filtersSchema = [];
